import { InstanceScreen } from 'component/navigation/instance';

export default function ModerationDashboardSpacesScreen() {
    return <InstanceScreen screenKey='spaces' />;
}
